import Vue from "vue";
import { http } from '@/shared/https'

export default class RouterService extends Vue {
    /**
     * Check the Grant Communication is started
     *-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*/
    public checkCommunicationStarted(to: any, from: any): Promise<any | null> {
        if(to.name === 'communicationReports') {
            let commId = to.params.communicationId;

            return http.get(`api/GrantCommunication/${commId}/isStarted`)
            .then((resp: any) => {
                return resp.data;
            })
            .catch(e => {
                return null;
            })
        }
    }

    public IsRecordExist(to: any, from: any): Promise<any | null> {
        if (to.name === "reviewApplication") {
            let reviewerId = to.params.reviewerId;
            let applicationId = to.params.applicationId;
            let entity = to.params.entity;
            let language = localStorage.getItem("language") || "en-US";

            return http.get(`api/ReviewExternal/${entity}/${reviewerId}/${applicationId}/${language}`)
                .then((resp: any) => {
                    return resp.data
                })
                .catch(e => {
                    return null;
                });
        }
    }
}